import type { ComponentProps } from 'react';
import { format } from 'date-fns';
import MutedText from 'components/common/MutedText';

interface Props extends ComponentProps<typeof MutedText> {
  date?: Date;
  muted?: boolean;
}

const TimeStamp = ({ date, muted = true, ...props }: Props) => {
  if (!date) {
    return null;
  }

  if (!muted) {
    return <span {...props}>{format(new Date(date), 'PPpp')}</span>;
  }

  return <MutedText {...props}>{format(new Date(date), 'PPpp')}</MutedText>;
};

export default TimeStamp;
